import React, { Component } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import { toast } from 'react-toastify';

import { Dialog, ElementLink } from '../../components';
import { deleteCategory } from '../../mutations';

export class CategoryCellView extends Component {
  state = {
    showsDeleteDialog: false,
  };
  notify = () =>
    toast.success('Category Successfully Deleted!', {
      position: 'top-right',
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: 'colored',
    });
  handleDeleteClicked = (event) => {
    event.preventDefault();
    event.stopPropagation();
    this.setState({ showsDeleteDialog: true });
  };

  handleCancelDelete = (event) => {
    event.preventDefault();
    event.stopPropagation();
    this.setState({ showsDeleteDialog: false });
  };

  handleConfirmDelete = (event) => {
    event.preventDefault();
    event.stopPropagation();
    this.setState({ showsDeleteDialog: false });

    const { lists, category, relay } = this.props;
    deleteCategory(relay.environment, category.id, lists.id, {
      onError: this.handleSubmitFailure,
    });
    this.notify();
  };

  render() {
    const { showsDeleteDialog } = this.state;
    const { category } = this.props;

    return (
      <ElementLink
        element="tr"
        to={`/categories/${category.id}/edit`}
        className="category-cell"
      >
        <td className="category-cell-name">
          {category.name}
          <Dialog
            className="deletion"
            isOpen={showsDeleteDialog}
            message={`Are you sure you want to delete ${category.name}?`}
            onConfirm={this.handleConfirmDelete}
            onCancel={this.handleCancelDelete}
          />
          <a
            className="category-delete-button"
            onClick={this.handleDeleteClicked}
          >
            ✘
          </a>
        </td>
      </ElementLink>
    );
  }
}

export default createFragmentContainer(CategoryCellView, {
  lists: graphql`
    fragment CategoryCell_lists on Lists {
      id
    }
  `,
  category: graphql`
    fragment CategoryCell_category on Category {
      id
      name
    }
  `,
});
